export default __webpack_public_path__ + "economies_m9ad1c6.png";